<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { type paramsSerializationOptions } from '../../../../composables/use-endless-scroll-api'
import type ApiInterface from '../../../../types/api-interface'
import EnumSelect from '../../../selects/enum-select'
import { type ComputedColumnInterface } from '../../DefaultTableInterfaces'
import { EnumSelectTableFilter } from '../../filters/Filters'
import { type EnumSelectHeaderInterface } from '../HeadersTableInterfaces'
import HeaderSort from './DefaultTableHeaderSort.vue'
import { type FilterData } from '../../filters/Filters'
import { prepareSmartFilterParams } from './prepareSmartFilterParams'

export default defineComponent({
  props: {
    api: {
      type: Object as PropType<ApiInterface>,
      default: undefined,
    },
    column: {
      type: Object as PropType<ComputedColumnInterface>,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    enableSorting: {
      type: Boolean,
    },
    sortOrder: {
      type: Boolean as PropType<boolean>,
    },
    onSort: {
      type: Function as PropType<() => void>,
    },
    params: {
      type: Array as PropType<FilterData[]>,
    },
    paramsSerialization: {
      type: String as PropType<paramsSerializationOptions>,
      default: 'default',
    },
  },
  setup(props) {
    const filter = props.column.filter as EnumSelectTableFilter
    const header = props.column.header as EnumSelectHeaderInterface

    const setValue = (val: { id: string, name: string } | undefined) => {
      filter.addValue(val)
    }

    const params = computed(() => prepareSmartFilterParams(props.column.hash, header.params || {}, props.params))

    return () => (

      <div class="ark-ui-table-enum-select-header default-table-header">
        <EnumSelect
          api={props.api}
          dataProvider={header.dataProvider}
          placeholder={props.column.name}
          endpoint={filter.endpoint}
          modelValue={filter.value}
          onValueChange={setValue}
          itemConverter={header.itemConverter}
          params={params.value}
          paramsSerialization={header.paramsSerialization || props.paramsSerialization}
          additionalItems={header.additionalItems}
          showItemsCount={5}
        />

        { props.enableSorting && props.onSort && (
          <HeaderSort column={props.column} onSort={props.onSort} sortField={props.sortField} sortOrder={props.sortOrder}/>
        ) }
      </div>

    )
  },
})
</script>

<style lang="scss" scoped>
.ark-ui-table-enum-select-header {
  display: flex;
  padding-right: 12px;
  // cursor: pointer;

  > *:first-child {
    width: 100%;
  }

  &.active,
  &:hover {
    & path {
      fill: #585B69;
    }
  }
}
</style>
